var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInteractionClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bounding_box",
    "data-name": "Bounding box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.24445,8.1792,13.831,6.76575l2.82093-2.82282,1.41363,1.414Zm-3.7677,3.30347-.00727-.002h0l.00727.002ZM8.17977,6.772,5.344,3.93793,3.93,5.35194l2.82886,2.828.00061-.00055.00623.00623ZM6.75724,13.8386,3.92313,16.67441l1.414,1.41395,2.828-2.82886-.00055-.00061.00623-.00623ZM6,10l-4.00751.00121,0,1.99879,3.99827-.0006,0-.00082h.0088Zm5.99626-4-.00062-4.0081-1.99908.00034,0,3.99886.00082,0V6Zm7.0732,9.39294,2.795,2.79395-3.678,3.677-.00006-.00012-.00684.00684-2.79321-2.79395-2.93713,2.938L8.91522,8.92664l.00647.00183-.00226-.00855,13.088,3.53394Zm-2.5459.00013,2.01288-2.01221-7.062-1.907.00232.00879,1.90466,7.05322,2.011-2.011,2.79388,2.794,1.13208-1.132Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractionClick);
export default __webpack_public_path__ + "static/media/Interaction-click.383b59b64862a6c3eaef4f223da4df75.svg";
export { ForwardRef as ReactComponent };